function add_to_cart(id, qty) {
  const add_url = window.Shopify.routes.root + "cart/add.js";
  const formData = new FormData();

  // Defaults
  formData.append("form_type", "product");
  formData.append("utf8", "✓");
  // Main Product
  formData.append(`items[0][id]`, parseInt(id));
  formData.append(`items[0][quantity]`, parseInt(qty));

  fetch(add_url, {
    method: "POST",
    body: formData,
  })
    .then(async (response) => {
      if (response.status === 200) {
        monster_refresh();
      } else {
        let res = await response.json();
        console.log(res);
        alert(`Error: ${res.description}`);
      }
      console.log(response);
      return response;
    })
    .catch((error) => {
      alert("Something went wrong!");
      console.error("Error:", error);
    });
}
document.addEventListener("DOMContentLoaded", function () {
  const W3ProductAccessories = document.getElementById(
    "w3-product-accessories"
  );
  if (W3ProductAccessories != null && W3ProductAccessories != undefined) {
    async function buildVariantsWithPrices(variantEls, productHandle) {
      const promises = Array.from(variantEls).map(async (z) => {
        let name = z.innerText;
        let value = z.value;
        let price = await getVariantPrice(productHandle, value);
        return {
          name,
          value,
          price,
        };
      });

      const variants = await Promise.all(promises);
      return variants;
    }

    async function getVariantPrice(productHandle, variantId) {
      try {
        const res = await fetch(`/products/${productHandle}.js`);
        const data = await res.json();
        const variant = data.variants.find((v) => v.id == variantId);
        if (variant) {
          return variant.price / 100;
        } else {
          console.log("Variant not found.");
          return null;
        }
      } catch (err) {
        console.error(err);
        return null;
      }
    }

    async function renderW3ProductAccessories() {
      const items = W3ProductAccessories.querySelectorAll(".accessories-item");
      const ACCESSORIES = await Promise.all(
        Array.from(items).map(async (item) => {
          let x = {
            title: "",
            price: "",
            sprice: "",
            link: "",
            handle: "",
            img: "",
            variants: [],
          };

          let title = item.querySelector("a.accessories-title");
          x.title = title.innerText;
          x.price = item.querySelector(".accessory-price")
            ? item.querySelector(".accessory-price").innerText
            : "";
          x.sprice =
            item.querySelector(".accessory-price.small")?.innerText ?? null;
          x.link = title.href;
          const parts = title.href.split("/products/");
          x.handle = parts[1].split("/")[0];
          let imgUrl = item.querySelector(".accessories-img-wrapper>img").src;
          let newUrl = imgUrl.replace("_thumb", "_compact");
          x.img = newUrl;

          // build variants with prices
          let variantEls = item.querySelectorAll(
            ".accessory-variant-select option"
          );
          x.variants = await buildVariantsWithPrices(variantEls, x.handle);

          return x;
        })
      );

      const refillSec = document.getElementById("refill-products");

      if (ACCESSORIES.length > 0) {
        document.getElementById("refill_sec").style.display = "block";
      }

      ACCESSORIES.forEach((elem) => {
        const productItem = document.createElement("div");
        productItem.className = "product-item";

        // content-wrapper div
        const contentWrapper = document.createElement("div");
        contentWrapper.className = "content-wrapper";

        // product image

        const img = document.createElement("img");
        img.src = elem.img;
        img.className = "product-img";
        img.alt = "product-img";
        img.loading = "lazy";
        img.width = 90;
        img.height = 90;

        // product info div (title + price)
        const infoDiv = document.createElement("div");
        infoDiv.style.flex = "1";

        // product title link
        const titleLink = document.createElement("a");
        titleLink.href = elem.link;
        titleLink.className = "product-title open-sans-semibold";
        titleLink.textContent = elem.title;

        // variant selector
        const variantSelector = document.createElement("select");

        elem.variants.forEach((varItem) => {
          let option = document.createElement("option");
          option.value = varItem.value;
          option.dataset.price = varItem.price;
          option.innerHTML = `${varItem.name} - $${varItem.price}`;
          variantSelector.appendChild(option);
        });
        const priceWrapper = document.createElement("div");
        priceWrapper.className = "d-flex align-items-center flex-wrap";
        priceWrapper.style.gap = "4px";

        // product price span
        const priceSpan = document.createElement("span");
        priceSpan.style.color = "black";
        priceSpan.style.display = "block";
        priceSpan.style.lineHeight = "1";
        priceSpan.className = "lato-medium item-price";
        priceSpan.textContent = elem.price;

        const spriceWrapper = document.createElement("div");
        spriceWrapper.className =
          "d-flex align-items-center flex-wrap sprice-wrapper";
        spriceWrapper.style.gap = "4px";

        const sTooltip = document.createElement("p");
        sTooltip.className = "stooltip";
        sTooltip.textContent =
          "The comparison price is the item MSRP and may not necessarily be the price at which the product is or was offered for sale.";

        const spriceSpan = document.createElement("span");
        spriceSpan.style.color = "gray";
        spriceSpan.style.display = "block";
        spriceSpan.style.textDecoration = "line-through";
        spriceSpan.style.lineHeight = "1";
        spriceSpan.className = "lato-medium item-price";
        spriceSpan.textContent = elem.price;

        const spriceIcon =
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.06697 11.2731C8.90339 11.2883 8.73918 11.2514 8.59788 11.1676C8.5469 11.1153 8.50835 11.0521 8.48506 10.9829C8.46177 10.9137 8.45435 10.8401 8.46334 10.7676C8.46715 10.6453 8.48175 10.5236 8.50697 10.404C8.53137 10.2666 8.56291 10.1307 8.6015 9.99668L9.03059 8.5203C9.07485 8.37457 9.10409 8.2247 9.11788 8.07302C9.11788 7.9094 9.13969 7.79665 9.13969 7.73121C9.14419 7.58724 9.11612 7.44411 9.05756 7.31251C8.999 7.18091 8.91147 7.06424 8.8015 6.97121C8.52747 6.76083 8.18621 6.65743 7.8415 6.6803C7.59446 6.68402 7.34935 6.72446 7.11422 6.8003C6.85725 6.8803 6.58694 6.97605 6.30331 7.08758L6.17969 7.56758C6.26331 7.53849 6.36516 7.50577 6.4815 7.4694C6.59249 7.43651 6.70755 7.41938 6.82331 7.41849C6.9857 7.40089 7.14911 7.44078 7.28513 7.53121C7.33084 7.58576 7.36504 7.649 7.38566 7.71712C7.40629 7.78524 7.41291 7.85684 7.40513 7.92758C7.40472 8.04987 7.39131 8.17176 7.36513 8.29121C7.33966 8.41849 7.30694 8.55302 7.26694 8.69483L6.83422 10.1785C6.79935 10.3164 6.77144 10.4559 6.75059 10.5966C6.7336 10.7171 6.72509 10.8386 6.72513 10.9603C6.72425 11.1052 6.75657 11.2483 6.8196 11.3788C6.88263 11.5093 6.9747 11.6236 7.08875 11.713C7.36701 11.9266 7.71311 12.0325 8.06328 12.0112C8.30986 12.0162 8.55558 11.9806 8.79056 11.9057C8.99663 11.8354 9.27178 11.7348 9.61603 11.6039L9.73241 11.1457C9.63916 11.1844 9.54313 11.216 9.44513 11.2402C9.32118 11.2685 9.19393 11.2796 9.06697 11.2731ZM9.5215 4.27305C9.3236 4.0913 9.06283 3.99352 8.79422 4.00033C8.52573 3.99428 8.26525 4.09196 8.06694 4.27305C7.70344 4.58649 7.66284 5.13527 7.97631 5.4988C8.00425 5.5312 8.03454 5.56149 8.06694 5.58943C8.48106 5.95983 9.10738 5.95983 9.52147 5.58943C9.88497 5.2729 9.92306 4.72165 9.60653 4.35815C9.58019 4.32785 9.55178 4.29942 9.5215 4.27305Z" fill="black"/><path d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM8 15.2727C3.98338 15.2727 0.727281 12.0166 0.727281 8C0.727281 3.98338 3.98338 0.727281 8 0.727281C12.0166 0.727281 15.2727 3.98338 15.2727 8C15.2727 12.0166 12.0166 15.2727 8 15.2727Z" fill="black"/></svg>';
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(spriceIcon, "image/svg+xml");
        const svgElement = svgDoc.documentElement;

        spriceWrapper.appendChild(spriceSpan);
        spriceWrapper.appendChild(svgElement);
        spriceWrapper.appendChild(sTooltip);

        priceWrapper.appendChild(priceSpan);
        if (elem.sprice) {
          priceWrapper.appendChild(spriceWrapper);
        }

        // append title, selector, price to infoDiv
        infoDiv.appendChild(titleLink);
        if (elem.variants.length > 1) {
          infoDiv.appendChild(variantSelector);
        }
        infoDiv.appendChild(priceWrapper);

        // append img and infoDiv to content-wrapper
        contentWrapper.appendChild(img);
        contentWrapper.appendChild(infoDiv);

        const btnWrapper = document.createElement("div");
        btnWrapper.className = "btn-wrapper";

        const quickViewBtn = document.createElement("div");
        quickViewBtn.className = "quick-view-btn";
        quickViewBtn.textContent = "Quick View";
        quickViewBtn.style.cursor = "pointer";
        quickViewBtn.style.marginBottom = "6px";
        quickViewBtn.style.fontSize = "14px";
        quickViewBtn.style.textAlign = "center";

        const parts = elem.link.split("/products/");
        const phandle = parts[1].split("/")[0];
        quickViewBtn.dataset.handle = phandle;
        quickViewBtn.dataset.variant = elem.variants[0].value;
        quickViewBtn.addEventListener("click", function () {
          const handle = this.dataset.handle;
          const variantId = this.dataset.variant;

          fetch(`/products/${handle}.js`)
            .then((res) => res.json())
            .then((product) => {
              // Product Title
              document.querySelector(
                "#productModal .product-details-section .h2"
              ).textContent = product.title;

              // Product Description
              document.querySelector(
                "#productModal .product-details-section .description"
              ).textContent = product.description.replace(/(<([^>]+)>)/gi, "");

              // Product Image
              const imageElement = document.querySelector(
                "#productModal .product-image-section img"
              );
              imageElement.src =
                product.images.length > 0
                  ? product.images[0]
                  : "https://via.placeholder.com/300x300";

              const addToCartBtnn = document.querySelector(
                "#productModal .add-to-cart"
              );
              const quantityInput = document.querySelector(
                "#productModal #quantity"
              );
              const selectWrapper = document.querySelector(
                "#productModal .select-wrapper"
              );
              selectWrapper.innerHTML = ""; // clear previous select if any

              let currentVariantId; // to store current variant id

              if (product.variants.length > 1) {
                const select = document.createElement("select");
                select.id = "variant-select";

                product.variants.forEach((variant) => {
                  const option = document.createElement("option");
                  option.value = variant.id;
                  option.textContent =
                    variant.title + ` - $${(variant.price / 100).toFixed(2)}`;
                  select.appendChild(option);
                });

                selectWrapper.appendChild(select);

                // Set default variant id from first option
                currentVariantId = select.value;

                // Update initial price
                const selectedVariant = product.variants.find(
                  (v) => v.id == select.value
                );
                document.querySelector(
                  "#productModal .product-details-section .price"
                ).textContent = `$${(selectedVariant.price / 100).toFixed(2)}`;

                // Set initial onclick with default variant and quantity
                addToCartBtnn.setAttribute(
                  "onclick",
                  `add_to_cart(${currentVariantId}, ${quantityInput.value})`
                );

                // Update on select change
                select.addEventListener("change", function () {
                  const selectedVariant = product.variants.find(
                    (v) => v.id == this.value
                  );
                  if (selectedVariant) {
                    currentVariantId = selectedVariant.id;
                    document.querySelector(
                      "#productModal .product-details-section .price"
                    ).textContent = `$${(selectedVariant.price / 100).toFixed(
                      2
                    )}`;
                    addToCartBtnn.setAttribute(
                      "onclick",
                      `add_to_cart(${currentVariantId}, ${quantityInput.value})`
                    );
                  }
                });
              } else {
                // Single variant
                const singleVariant = product.variants[0];
                currentVariantId = singleVariant.id;
                document.querySelector(
                  "#productModal .product-details-section .price"
                ).textContent = `$${(singleVariant.price / 100).toFixed(2)}`;
                addToCartBtnn.setAttribute(
                  "onclick",
                  `add_to_cart(${currentVariantId}, ${quantityInput.value})`
                );
              }

              // Update onclick on quantity input change
              quantityInput.addEventListener("change", function () {
                addToCartBtnn.setAttribute(
                  "onclick",
                  `add_to_cart(${currentVariantId}, ${quantityInput.value})`
                );
              });

              // Show modal
              document.getElementById("productModal").style.display = "block";
            })
            .catch((err) => {
              console.error("Product fetch error:", err);
            });
        });
        // add-to-cart button
        const addBtn = document.createElement("button");
        addBtn.type = "button";
        addBtn.className = "add-btn";
        addBtn.textContent = "Add";
        addBtn.setAttribute(
          "onclick",
          `add_to_cart(${elem.variants[0].value})`
        );

        btnWrapper.appendChild(quickViewBtn);
        btnWrapper.appendChild(addBtn);

        variantSelector.addEventListener("change", () => {
          const selectedOption =
            variantSelector.options[variantSelector.selectedIndex];
          const price = selectedOption.dataset.price;

          // Convert to float and format as currency
          const formattedPrice = Number(price).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          });

          priceSpan.textContent = formattedPrice;

          addBtn.setAttribute(
            "onclick",
            `add_to_cart(${variantSelector.value}, 1)`
          );
        });

        // append content-wrapper and button to product-item
        productItem.appendChild(contentWrapper);
        productItem.appendChild(btnWrapper);

        refillSec.append(productItem);
      });
    }

    function waitForW3ProductAccessoriesToRender() {
      setTimeout(function () {
        let list = W3ProductAccessories.querySelector(".accessories-item");
        if (list != null && list != undefined) {
          renderW3ProductAccessories();
        } else {
          waitForW3ProductAccessoriesToRender();
        }
      }, 800);
    }

    waitForW3ProductAccessoriesToRender();

    let quickViewBtn = document.querySelectorAll(".quick-view-btn");
    quickViewBtn.forEach((element) => {
      element.addEventListener("click", (e) => {
        alert("clicked");
      });
    });
  }
  const modal = document.getElementById("productModal");
  const closeBtn = document.getElementById("closeModal");

  closeBtn.addEventListener("click", () => {
    modal.style.display = "none";
  });

  window.addEventListener("click", (e) => {
    if (e.target == modal) {
      modal.style.display = "none";
    }
  });
});
